var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00156 13.4C10.5362 13.4 13.4016 10.5346 13.4016 6.99998C13.4016 3.46535 10.5362 0.599976 7.00156 0.599976C3.46694 0.599976 0.601562 3.46535 0.601562 6.99998C0.601562 10.5346 3.46694 13.4 7.00156 13.4ZM9.96725 6.43429L7.56725 4.03429C7.25483 3.72187 6.7483 3.72187 6.43588 4.03429L4.03588 6.43429C3.72346 6.74671 3.72346 7.25324 4.03588 7.56566C4.3483 7.87808 4.85483 7.87808 5.16725 7.56566L6.20156 6.53135L6.20156 9.39998C6.20156 9.8418 6.55973 10.2 7.00156 10.2C7.44339 10.2 7.80156 9.8418 7.80156 9.39998V6.53135L8.83588 7.56566C9.1483 7.87808 9.65483 7.87808 9.96725 7.56566C10.2797 7.25324 10.2797 6.74671 9.96725 6.43429Z",
    fill: "#9CA3AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.34f85ab6.svg";
export { ForwardRef as ReactComponent };